import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import CarLoanType from "@/module/main/dto/CarLoanTypeEnum";

export default function isLargeCarLoan(financedSubjectType: FinancedSubjectType, orderType: OrderType,
    carLoanType: CarLoanType): boolean
{
    return financedSubjectType === FinancedSubjectType.ORDER
        && orderType === OrderType.CAR_LOAN
        && carLoanType === CarLoanType.LARGE_CARS;
}
